import ManualBillingDocumentLabel from '@/generated/controls/manualBillingDocument/ManualBillingDocumentLabel.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentLabel
})
